import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  collegeService,
  CollegeProfileUpdateType,
} from "@/services/college.service";
import { notifyError, notifySuccess } from "@/lib/notification";

export const COLLEGE_KEYS = {
  profile: ["college", "profile"] as const,
};

export const useCollegeProfileQuery = () => {
  return useQuery({
    queryKey: COLLEGE_KEYS.profile,
    queryFn: () => collegeService.fetchCollegeProfile(),
  });
};

export const useUpdateCollegeProfileMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CollegeProfileUpdateType) =>
      collegeService.updateCollegeProfile(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: COLLEGE_KEYS.profile });
      notifySuccess("College profile updated successfully!");
    },
    onError: (error: unknown) => {
      const err = error as {
        response?: { data?: { error?: { message?: string } } };
        message?: string;
      };
      const errorMessage =
        err.response?.data?.error?.message ||
        err?.message ||
        "Failed to update college profile.";
      notifyError(errorMessage);
    },
  });
};
